import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.success) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-4" data-testid="admin-login-page">
      <form onSubmit={handleSubmit} className="bg-white rounded-lg p-8 w-full max-w-sm shadow-xl">
        <h1 className="text-2xl font-serif-heading font-bold text-navy mb-1">HouseTalk Daily</h1>
        <p className="text-sm text-slate-500 mb-6">Admin Dashboard Login</p>
        {error && <p className="text-red-600 text-sm mb-3" data-testid="admin-login-error">{error}</p>}
        <div className="space-y-3">
          <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-gold hover:bg-gold-600 text-navy font-bold">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
